/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollDeductionsEditor extends _Ext.GridEditorBase<PayrollEmployeeDetailsRow> {
        protected getColumnsKey() { return "HR.PayrollEmployeeDetails"; }
        protected getLocalTextPrefix() { return PayrollEmployeeDetailsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
     
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
 
            return buttons;
        }

        public adddetail(detail: PayrollEmployeeDetailsRow) { 
            this.view.addItem(detail)
        }
    }
}